import { getState } from '../../shared/store/store';

/** Som de estúdio sintetizado com Web Audio: sem arquivos, sem dependência. */
type Wave = OscillatorType;

let ctx: AudioContext | null = null;
let muted = false;

const on = (): boolean => getState().config.sound && !muted;

function ac(): AudioContext {
  if (!ctx) {
    const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    ctx = new Ctor();
  }
  return ctx;
}

function beep(freq: number, dur: number, type: Wave = 'square', gain = .05): void {
  if (!on()) return;
  const c = ac(), o = c.createOscillator(), g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(gain, c.currentTime);
  g.gain.exponentialRampToValueAtTime(.0001, c.currentTime + dur);
  o.connect(g).connect(c.destination); o.start(); o.stop(c.currentTime + dur);
}

export const Snd = {
  tick(): void { beep(1200 + Math.random() * 400, .035, 'square', .03); },

  lock(): void {
    if (!on()) return;
    const c = ac(), o = c.createOscillator(), g = c.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(420, c.currentTime);
    o.frequency.exponentialRampToValueAtTime(70, c.currentTime + .28);
    g.gain.setValueAtTime(.16, c.currentTime);
    g.gain.exponentialRampToValueAtTime(.0001, c.currentTime + .32);
    o.connect(g).connect(c.destination); o.start(); o.stop(c.currentTime + .34);
  },

  fanfare(): void {
    if (!on()) return;
    [523, 659, 784, 1046, 1318].forEach((f, i) => setTimeout(() => beep(f, .5, 'triangle', .09), i * 110));
    setTimeout(() => beep(1046, .9, 'sawtooth', .05), 600);
  },

  whoosh(): void {
    if (!on()) return;
    const c = ac(), b = c.createBuffer(1, Math.floor(c.sampleRate * .5), c.sampleRate), d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 2);
    const s = c.createBufferSource(); s.buffer = b;
    const f = c.createBiquadFilter(); f.type = 'bandpass';
    f.frequency.setValueAtTime(380, c.currentTime);
    f.frequency.exponentialRampToValueAtTime(2600, c.currentTime + .45);
    const g = c.createGain(); g.gain.value = .11;
    s.connect(f).connect(g).connect(c.destination); s.start();
  },

  riser(dur: number): void {
    if (!on()) return;
    const c = ac(), o = c.createOscillator(), g = c.createGain(), f = c.createBiquadFilter();
    o.type = 'sawtooth';
    o.frequency.setValueAtTime(90, c.currentTime);
    o.frequency.exponentialRampToValueAtTime(520, c.currentTime + dur);
    f.type = 'lowpass';
    f.frequency.setValueAtTime(400, c.currentTime);
    f.frequency.exponentialRampToValueAtTime(3200, c.currentTime + dur);
    g.gain.setValueAtTime(.0001, c.currentTime);
    g.gain.exponentialRampToValueAtTime(.06, c.currentTime + dur * .85);
    g.gain.exponentialRampToValueAtTime(.0001, c.currentTime + dur);
    o.connect(f).connect(g).connect(c.destination); o.start(); o.stop(c.currentTime + dur + .05);
  },

  ding(): void { [880, 1320].forEach((f, i) => setTimeout(() => beep(f, .55, 'triangle', .07), i * 90)); },

  heartbeat(): void { [0, 300, 900, 1200].forEach(d => setTimeout(() => beep(62, .3, 'sine', .22), d)); },

  coins(): void {
    if (!on()) return;
    for (let i = 0; i < 16; i++) setTimeout(() => {
      beep(1700 + Math.random() * 2000, .11, 'triangle', .045);
      beep(2700 + Math.random() * 2400, .06, 'sine', .028);
    }, i * 70 + Math.random() * 60);
  },

  toggle(): boolean { muted = !muted; return muted; },
  get muted(): boolean { return muted; },
  resume(): void { try { void ac().resume(); } catch { /* sem áudio */ } }
};
